import { Flex } from '@chakra-ui/react';
import React from 'react';
import { useSelector } from 'react-redux';

import { makeGetShouldShowPreferredProviderTiers } from 'Containers/App/selectors';
import { useProviderSelectionContext } from 'Contexts/providerSelectionContext';
import { getPreferredNetworkProviderName } from 'Utils/helpers';

import { ProviderList } from './ProvidersList';

export const InNetworkProviders = ({ plan, recommendation }) => {
  const { filteredProviders, onOpenProviderModal, providerDetails } = useProviderSelectionContext();

  const shouldShowPreferredProviderTiers = useSelector(makeGetShouldShowPreferredProviderTiers());

  const inNetworkProviderList = filteredProviders[plan.planId]
    ? filteredProviders[plan.planId]?.inNetwork
    : [];

  const preferredNetworkProviderList = filteredProviders[plan.planId]
    ? filteredProviders[plan.planId]?.preferredNetwork
    : [];

  const { isMostPreferredEnabled, mostPreferredProviderName } = getPreferredNetworkProviderName(
    recommendation,
    shouldShowPreferredProviderTiers,
  );
  const showPreferredNetworkProviders =
    shouldShowPreferredProviderTiers &&
    preferredNetworkProviderList &&
    preferredNetworkProviderList.length > 0;

  return (
    <Flex
      justify={['center']}
      align={['flex-start']}
      direction="column"
      gap={2}
      border="var(--border-thick)"
      borderTop="0"
      px={4}
      pr={[4, 0]}
      py={[3, 0]}
      borderBottomRadius={6}
      h={showPreferredNetworkProviders ? ['auto', 20] : ['auto', 10]}
      overflow="hidden"
    >
      {showPreferredNetworkProviders && (
        <ProviderList
          networkType="preferred-network"
          hasSavedProviders={providerDetails.length > 0}
          onOpenProviderModal={onOpenProviderModal}
          providers={preferredNetworkProviderList}
          shouldShowPreferredProviderTiers={shouldShowPreferredProviderTiers}
          isMostPreferredEnabled={isMostPreferredEnabled}
          mostPreferredProviderName={mostPreferredProviderName}
        />
      )}
      <ProviderList
        networkType="in-network"
        hasSavedProviders={providerDetails.length > 0}
        onOpenProviderModal={onOpenProviderModal}
        providers={inNetworkProviderList}
        shouldShowPreferredProviderTiers={shouldShowPreferredProviderTiers}
        isMostPreferredEnabled={false}
        mostPreferredProviderName=""
      />
    </Flex>
  );
};
